import i18next from 'i18next'

export const getMenuItems = () => [
  {
    key: 'menu',
    label: 'MENU',
    isTitle: true,
  },
]

export const getMenuItems2 = () => [
  {
    key: 'blog',
    label: 'Blog',
    icon: 'solar:widget-2-outline',
    url: '/blog',
  },
  {
    key: 'resources',
    label: 'Recursos',
    icon: 'solar:widget-add-outline',
    url: '/resources',
  },
]

i18next.on('languageChanged', () => {
  window.dispatchEvent(new Event('languageChanged'))
})
